import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  boxShadowBlack12,
  standardFocusState,
} from 'approot/shared/styles/borders.style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';
import {
  spacing12,
  spacing4,
  spacing40,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import { PStyled } from 'approot/shared/styles/typography.style';
import { ActivitySettingsCheckpoint } from './activity.style';

export const ActivityViewContainer = styled.div`
  position: absolute;
  left: -${rem(30)};
  top: -${rem(spacing40)};
  z-index: 11;
`;

type ActivityViewProps = {
  $isRound?: boolean;
  $isCircle?: boolean;
};

const activityViewBaseCss = css`
  ${baseFlexCss}
  ${boxShadowBlack12}
  background-color: ${grey1};
  border: 1px solid ${grey5};
  padding: ${rem(spacing4)};
  position: relative;
  z-index: 1;
`;

export const ActivityViewDifferentiation = styled.div<ActivityViewProps>`
  ${activityViewBaseCss}
  border-radius: ${({ $isRound }) => ($isRound ? rem(40) : rem(4))};
`;

export const ActivityViewButtonsWrapper = styled.div<ActivityViewProps>`
  ${activityViewBaseCss}
  border-radius: ${({ $isRound }) =>
    $isRound ? `${rem(50)} ${rem(8)} ${rem(8)} ${rem(50)}` : rem(4)};
  ${({ $isCircle }) => $isCircle && `border-radius: ${rem(50)}`}
`;

export const ActivityViewDetailsButton = styled.button<ActivityViewProps>`
  ${standardFocusState}
  position: relative;
  border: none;
  background: none;
  padding: 0;

  &:hover {
    cursor: pointer;
  }

  &:focus {
    border-radius: ${({ $isRound }) => ($isRound ? rem(40) : rem(4))};
  }
`;

export const ActivityViewCheckpoint = styled(ActivitySettingsCheckpoint)`
  position: absolute;
  right: -${rem(spacing12)};
  top: -${rem(spacing8)};
`;

export const ActivityViewText = styled(PStyled).attrs({
  marginBottom: 0,
})`
  margin-left: ${rem(spacing12)};
  margin-right: ${rem(spacing12)};
`;
